export default __webpack_public_path__ + "static/media/truck.4c5a7df9.png";